import { ElementType } from 'react'
import { styled } from '@mui/material'

const LineClampedDiv = styled('span')<{ clamp: number }>`
  display: block;
  display: -webkit-box;
  line-clamp: ${({ clamp }) => clamp};
  -webkit-line-clamp: ${({ clamp }) => clamp};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export type LineClampedTextProps = React.HTMLAttributes<HTMLDivElement> & {
  clamp?: number
  component?: ElementType
}

/**
 * A simple component to render text with line clamping and ellipsis.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-clamp
 */
export const LineClampedText = ({ children, clamp = 1, component, ...props }: LineClampedTextProps) => {
  return (
    <LineClampedDiv as={component} clamp={clamp} title={children as string} {...props}>
      {children}
    </LineClampedDiv>
  )
}
